import { Controller } from "@hotwired/stimulus"

// Handles notification auto-dismiss and manual dismiss
export default class extends Controller {
  static values = {
    dismissAfter: { type: Number, default: 5000 },
  }

  connect() {
    // Auto-dismiss after configured time
    if (this.dismissAfterValue > 0) {
      this.timeout = setTimeout(() => {
        this.dismiss()
      }, this.dismissAfterValue)
    }
  }

  disconnect() {
    // Clear timeout if element is removed before auto-dismiss
    if (this.timeout) {
      clearTimeout(this.timeout)
    }
  }

  dismiss() {
    // Fade out animation
    this.element.style.transition = "opacity 300ms ease-out"
    this.element.style.opacity = "0"

    setTimeout(() => {
      this.element.remove()
    }, 300)
  }
}
